$(document).ready(function () {
  tiOptimizeCartChanges();
  mobileShift();
  mobileChanges();
  addSticky();

  function tiOptimizeCartChanges() {
    //cart btn
    if (typeof cart_img_cart_info === "undefined") return;
    const cartBtn = document.querySelector(
      "#cartform .cartdetails_container button.js-checkout-btn.checkout-btn"
    );
    if (cartBtn) {
      cartBtn.innerText = "Proceed To Checkout";
    }
    //cart form message
     const cartForm = document.querySelector("#cartform");
     // Check for 'ultra thin' (case insensitive) and update alert message accordingly
      const lineItems = document.querySelectorAll('ul.line-items li span');
      let ultraThinFound = false;

      lineItems.forEach(item => {
         if (item.textContent.toLowerCase().includes('ultra thin')) {
            ultraThinFound = true;
         }
      });

      let alertMessage = `<div class="ti-alert-container">
      </div>`;

      if (ultraThinFound) {
         alertMessage = `<div class="ti-alert-container">
            <span><img src="${cart_img_cart_info}"/><p>Ultra Thin lenses require additional processing time. </p></span>
         </div>`;
      }
    //-end- cart message

    if (cartForm) {
      cartForm.insertAdjacentHTML("beforebegin", alertMessage);
    }
    const products = document.querySelectorAll(
      "li.item.cart-product-item.clearfix"
    );
    const totalItems = products.length;
    const cartHeader = document.querySelector(".central.py-medium.content .h2");
    if (totalItems > 0) {
      cartHeader.innerText = `Cart (${totalItems})`;
    }
    if (totalItems > 1) {
      document
        .querySelector("#cartform .cart_list_container")
        .classList.add("ti-mulitple-products");
    }
    const description = document.querySelectorAll(
      "#cartform .cart_list_container .desc .title"
    );
    description.forEach(function (item) {
      const productTitle = item.querySelector("a");
      const price = `<span class="ti-price">Price</span>`;
      const subtotalLine = `<li class="ti-subtotal-container"><span class="ti-subtotal">Subtotal</span><span class="ti-product-price"></span></li>`;
      const lineItem = item.querySelector(".line-items");
      const individualProduct = item.querySelector(
        ".line-items li .cart-price li"
      );
      const parentElement = item.parentElement;
      const beforeParent = `<div class="link-container"><div class="ti-link-contain"></div></div>`;
      if (parentElement) {
        parentElement.insertAdjacentHTML("beforebegin", beforeParent);
      }
      const linkContain =
        item.parentElement.previousElementSibling.querySelector(
          ".ti-link-contain"
        );
      if (linkContain) {
        linkContain.insertAdjacentElement("afterbegin", productTitle);
      }
      if (item) {
        item.insertAdjacentHTML("afterbegin", price);
      }

      if (lineItem) {
        const parent = item.closest(".desc");
        parent.insertAdjacentHTML("afterend", subtotalLine);
      }
    });
    const productList = document.querySelectorAll(
      ".cart_list_container .cart-list li.item.cart-product-item.clearfix"
    );
    productList.forEach(function (item) {
      const themeMoney = item.querySelector(
        ".item-price .theme-money"
      ).innerText;
      const priceItems = item.querySelectorAll(
        ".item-price .cart-item-price li"
      );
      const subtotal = item.querySelector(".item-price .subtotal_text");
      // if(item.classList.contains(''))

      let subtotalValue = 0;
      priceItems.forEach(function (priceItem) {
        const price = priceItem.innerText;
        if (price) {
          subtotalValue += parseFloat(price.replace("$", ""));
        }
      });

      if (themeMoney) {
        subtotalValue += parseFloat(themeMoney.replace("$", ""));
      }

      const priceSubtotal = item.querySelector(".ti-product-price");
      priceSubtotal.innerHTML = `<span class="ti-show-mobile"></span>$${subtotalValue}`;
    });
    //changing innerHTML of remove button
    const removeBtn = document.querySelectorAll(
      "#cartform .cart_list_container .remove_reconfigure .js-remove-item.remove"
    );
    removeBtn.forEach(function (item) {
      item.innerText = "";
    });
    const mobileRemoveBtn = document.querySelectorAll(
      "#cartform .cart_list_container .mobile_remove .js-remove-item.remove"
    );
    mobileRemoveBtn.forEach(function (item) {
      item.innerText = "";
    });
    //changing cart layout
    const cartTotal = document.querySelectorAll(
      ".cartdetails_container .under-cart .subtotal-row"
    );
    cartTotal.forEach(function (item) {
      const freeShippingLine = `<div class="subtotal ti-ship-free"><span>Shipping</span><span>Free</span></div>`;
      const taxesCalculated = `<div class="ti-tax-text"><span>Taxes calculated at checkout</span></div>`;
      item.insertAdjacentHTML("beforebegin", freeShippingLine);
      item.insertAdjacentHTML("afterend", taxesCalculated);
    });
    //cart tax calculations
    // const textBelowCTA = document.querySelector('.cartdetails_container .under-cart .cart-policies.rte')
    // if(textBelowCTA){
    //   textBelowCTA.innerHTML = `Pay in 4 interest-free installments of $35.00 with shop pay Learn More`
    // }
    //update chat messagee
    const currentMessage = document.querySelector(
      ".cartdetails_container .under-cart .cart_chat_message"
    );
    const newMessage = `<span class="ti-chat-text">Need help with your order? <a href="https://us.jins.com/pages/contact-us#rp-customer-widget-home">Chat</a> with<br> our Specialists</span><div class="ti-chat-list"><span><img src="${cart_img_checkmark}"/><p>Includes frame case and lens cloth</p></span><span><img src="${cart_img_checkmark}"/><p>Free 30-day returns</p></span><span><img class="ti-down" src="${cart_img_checkmark}"/><p>1-Year limited warranty</p></span></div>`;
    if (currentMessage) {
      currentMessage.innerHTML = newMessage;
    }
    const addBorderContainer = `<div class="ti-border-container"></div>`;
    const underTaxText = document.querySelector(
      "#cartform .cartdetails_container .under-cart .ti-tax-text"
    );
    const freeShipText = document.querySelector(
      "#cartform .cartdetails_container .under-cart .subtotal.ti-ship-free"
    );
    const subtotalRowText = document.querySelector(
      "#cartform .cartdetails_container .under-cart .subtotal-row"
    );
    const cartCheckoutBtn = document.querySelector(
      "#cartform .cartdetails_container .under-cart button.js-checkout-btn.checkout-btn"
    );
    const cartPolicy = document.querySelector(
      "#cartform .cartdetails_container .under-cart .cart-policies.rte"
    );
    const cartTerms = document.querySelector(
      "#cartform .cartdetails_container .under-cart  .cart-terms"
    );

    const underCart = document.querySelector(
      "#cartform .cartdetails_container .under-cart"
    );
    if (underCart) {
      underCart.insertAdjacentHTML("afterbegin", addBorderContainer);
    }
    const borderContainer = document.querySelector(
      "#cartform .cartdetails_container .under-cart .ti-border-container"
    );
    const cartArr = [
      freeShipText,
      subtotalRowText,
      underTaxText,
      cartCheckoutBtn,
      cartPolicy,
    ];
    if (borderContainer) {
      cartArr.forEach((item) => {
        borderContainer.appendChild(item);
      });
    }
    if (cartTerms) {
      borderContainer.insertAdjacentElement("beforeend", cartTerms);
    }
    const mobileChatMessage = document.querySelector(".mobile_view");
    if (mobileChatMessage) {
      mobileChatMessage.innerHTML = newMessage;
    }
  }
  function addSticky() {
    let waitForMobile = setInterval(function () {
      if (document.querySelector(".ti-mobile")) {
        clearInterval(waitForMobile);
        const stickyBtn = `<div class="ti-sticky"><button class="checkout-btn" name="checkout" value="Check out">Proceed To Checkout</button></div>`;
        if (document.querySelector(".ti-mobile")) {
          document
            .querySelector(".ti-mobile")
            .insertAdjacentHTML("beforebegin", stickyBtn);
        }
      }
    }, 500);
  }
  function listItemsGone() {
    let waitForMobileSide = setInterval(function () {
      if (document.querySelector(".ti-mobile")) {
        clearInterval(waitForMobileSide);
        const mobileProducts = document.querySelectorAll(
          ".cart_list_container .cart-list li.item.cart-product-item.clearfix"
        );
        mobileProducts.forEach(function (item) {
          const mobileList = item.querySelector(".cart-item-price ul");
          let hasNegativeValue = false;

          mobileList.querySelectorAll("li").forEach(function (li) {
            if (parseInt(li.innerText, 10) < 2) {
              hasNegativeValue = true;
            }
          });

          // Check if there are exactly two items in the list
          if (mobileList.querySelectorAll("li").length === 2) {
            mobileList.classList.add("adjust");
            const newListItem = document.createElement("li");
            newListItem.innerText = "";
            mobileList.insertAdjacentElement("beforeend", newListItem);
          }

          // If there are negative values, add a new <li> element with a value of 3 at the beginning of the list
          if (hasNegativeValue) {
            const newListItem = document.createElement("li");
            newListItem.innerText = "3";
            mobileList.insertAdjacentElement("afterbegin", newListItem);
          }
        });
      }
    }, 500);
  }
  function tabletListItemsGone() {
    let waitForMobileSide = setInterval(function () {
      if (document.querySelector(".ti-tablet")) {
        clearInterval(waitForMobileSide);
        const mobileProducts = document.querySelectorAll(
          ".cart_list_container .cart-list li.item.cart-product-item.clearfix"
        );
        mobileProducts.forEach(function (item) {
          const mobileList = item.querySelector(".cart-item-price ul");
          let hasNegativeValue = false;

          mobileList.querySelectorAll("li").forEach(function (li) {
            if (parseInt(li.innerText, 10) < 2) {
              hasNegativeValue = true;
            }
          });

          // Check if there are exactly two items in the list
          if (mobileList.querySelectorAll("li").length === 2) {
            mobileList.classList.add("adjust");
            const newListItem = document.createElement("li");
            newListItem.innerText = "";
            mobileList.insertAdjacentElement("beforeend", newListItem);
          }

          // If there are negative values, add a new <li> element with a value of 3 at the beginning of the list
          if (hasNegativeValue) {
            const newListItem = document.createElement("li");
            newListItem.innerText = "3";
            mobileList.insertAdjacentElement("afterbegin", newListItem);
          }
        });
      }
    }, 500);
  }

  function mobileChanges() {
    let waitForMobileClas = setInterval(function () {
      const productIsToggled = document.querySelector(".product-is-toggled");
      if (document.querySelector(".ti-show-mobile") && !productIsToggled) {
        clearInterval(waitForMobileClas);
        //creating click event for down arrow
        const listItem = document.querySelectorAll(
          ".template-cart #cartform .cart_list_container .cart-list li.item.cart-product-item.clearfix"
        );
        listItem.forEach(function (item) {
          const subTotalContaner = item.querySelector(".ti-subtotal-container");
          subTotalContaner.addEventListener("click", function () {
            item.classList.toggle("product-is-toggled");
          });
        });
        // const downArrow = document.querySelectorAll('.ti-subtotal-container')
        // downArrow.forEach(function(arrow){
        //   arrow.addEventListener('click', function(e){
        //     console.log('yo')
        //     document.querySelector('body').classList.toggle('product-is-toggled')
        //   })
        // })
        // Get the elements
        const container = document.querySelector(
          "#cartform .cartdetails_container"
        );
        const buttons = document.querySelector(
          "#cartform .cartdetails_container button.js-checkout-btn.checkout-btn"
        );
      }
    });
  }
  function toggleChanges() {
    let waitForToggled = setInterval(function () {
      if (
        document.querySelector(
          ".product-is-toggled .ti-subtotal-container .ti-product-price .ti-show-mobile"
        )
      ) {
        console.log("product is here");
        clearInterval(waitForToggled);
        const downArrow = document.querySelectorAll(".ti-subtotal-container");
        downArrow.forEach(function (arrow) {
          arrow.addEventListener("click", function () {
            console.log("yes");
            document
              .querySelector("body")
              .classList.remove("product-is-toggled");
          });
        });
      }
    }, 500);
  }

  function mobileShift() {
    // Get a reference to the element you want to modify
    const cartListContainer = document.querySelector(
      "#cartform .cart_list_container"
    );
    // Define a function to add or remove the class based on screen size
    function handleScreenSizeChange(mq) {
      if (mq.matches) {
        // Add the class if the screen size is less than 768 pixels
        cartListContainer.classList.add("ti-mobile");
      } else {
        // Remove the class if the screen size is 768 pixels or greater
        cartListContainer.classList.remove("ti-mobile");
      }
    }
    // Listen for changes in screen size using window.matchMedia()
    const mediaQuery = window.matchMedia("(max-width: 767px)");
    mediaQuery.addListener(handleScreenSizeChange);
    // Call the function once to apply the class initially
    handleScreenSizeChange(mediaQuery);
    // toggleChanges();
  }

  function stickyActivate() {
    let waitForStickyMobile = setInterval(function () {
      if (document.querySelector(".ti-mobile")) {
        clearInterval(waitForStickyMobile);

        // Calculate the offset of the button
        const button = document.querySelector(
          "#cartform .cartdetails_container button.js-checkout-btn.checkout-btn"
        );
        const buttonOffset = button.offsetTop + button.offsetHeight;

        // Get the sticky element
        const tiSticky = document.querySelector("body");

        // Add scroll event listener to the window
        window.addEventListener("scroll", function (e) {
          e.preventDefault();

          // Get the current scroll position
          const scrollTop =
            window.pageYOffset ||
            document.documentElement.scrollTop ||
            document.body.scrollTop ||
            0;

          // Check if the scroll position is past the button offset
          if (scrollTop > buttonOffset) {
            // Add the scroll class to the sticky element
            tiSticky.classList.add("scroll");

            // Check if the button is visible on the screen
            const buttonRect = button.getBoundingClientRect();
            const buttonTop = buttonRect.top;
            if (buttonTop >= 0 && buttonTop < window.innerHeight) {
              // Remove the scroll class from the sticky element
              tiSticky.classList.remove("scroll");
            }
          } else {
            // Remove the scroll class from the sticky element
            tiSticky.classList.remove("scroll");
          }
        });
        const mobileLists = document.querySelectorAll(
          ".cart_list_container li.item.cart-product-item.clearfix"
        );
        mobileLists.forEach(function (item) {
          const mobileTheme = item.querySelector(".theme-money");
          const originalText = mobileTheme.firstChild;
          const newSpan = document.createElement("span");
          // Insert the new span element before the original text node
          mobileTheme.insertBefore(newSpan, originalText);
          // Append the original text node to the new span element
          newSpan.appendChild(originalText);
        });
      }
    });
  }
  function triggerClick() {
    let waitForStickyBtn = setInterval(function () {
      if (document.querySelector(".ti-sticky button.checkout-btn")) {
        clearInterval(waitForStickyBtn);
        const tiStickyBtn = document.querySelector(
          ".ti-sticky button.checkout-btn"
        );
        tiStickyBtn.addEventListener("click", function (e) {
          console.log("click form");
          e.preventDefault();
          const cartForm = document.querySelector(
            "#cartform .under-cart .ti-border-container button.js-checkout-btn.checkout-btn"
          );
          cartForm.click();
        });
      }
    }, 500);
  }
  listItemsGone();
  triggerClick();
  stickyActivate();
  tabletListItemsGone();

  var waitForElements = setInterval(() => {
    const pageContainer = document.querySelector(".cart_list_container");
    if (typeof ranCartOptimization === "undefined" && pageContainer) {
      window.ranCartOptimization = true;
      clearInterval(waitForElements);
      //Scope CSS
      document.body.classList.add("ti32");
      //Add Test Functions Here
      moveProductTitle();
      addRemoveLinkAfterTitle();
      insertMarkup();
      insertTitleBreak();
      rearrangeAndStyle();
      toggleDetails();
      updateCartPrices();
      modifyCartItems();
      rearrangeDivs();
      addBorderDiv();
      initializeMobileCheckoutBehavior();
      addHandlers();
      transplantAlertContainer();
      tiTESTNAMETracking();
    }
  }, 100);
});

// Path: assets/cart-customization.css
// Cart v2

const moveProductTitle = () => {
  const cartItems = document.querySelectorAll(".cart-product-item");
  cartItems.forEach((cartItem) => {
    const imageElement = cartItem.querySelector(".col-image > a");
    const linkContainElement = cartItem.querySelector(".ti-link-contain");
    if (imageElement && linkContainElement) {
      imageElement.after(linkContainElement);
    }
  });
};
const addRemoveLinkAfterTitle = () => {
  const cartItems = document.querySelectorAll(".cart-product-item");
  cartItems.forEach((cartItem) => {
    const linkContainElement = cartItem.querySelector(".ti-link-contain");
    const removeElement = cartItem.querySelector(".js-remove-item.remove");
    if (linkContainElement && removeElement) {
      const clonedRemoveElement = removeElement.cloneNode(true);
      clonedRemoveElement.textContent = "Remove";
      clonedRemoveElement.classList.add("custom-remove-style");
      clonedRemoveElement.addEventListener("click", (event) => {
        event.preventDefault();
        removeElement.click();
      });
      const newLineElement = document.createElement("br");
      linkContainElement.append(newLineElement, clonedRemoveElement);
    }
  });
};

const insertMarkup = () => {
  const borderContainer = document.querySelector(".ti-border-container");
  if (borderContainer) {
    // Hide the original container
    borderContainer.style.display = "none";

    // Get the original Subtotal value
    const originalSubtotalElem =
      borderContainer.querySelector(".subtotal .amount");
    const originalSubtotalValue = originalSubtotalElem
      ? originalSubtotalElem.textContent.trim()
      : "0";

    const originalCartAmount = document.querySelector(
      "[data-section-type=cart-template] h1"
    );
    const originalCartValue = originalCartAmount
      ? originalCartAmount.textContent.trim()
      : "0";

    const numberMatch = originalCartValue.match(/\((\d+)\)/);
    const number = numberMatch ? numberMatch[1] : "0";

    // Check if the number is "1", and use the singular form if it is
    const newText = `${number} ${number === "1" ? "item" : "items"}`;

    // Create a new container for your custom markup, interpolating the values directly
    const newContainer = document.createElement("div");
    newContainer.classList.add("ti-border-container");
    newContainer.innerHTML = `
    <div class="order-summary-title">Order Summary</div>
    <div class="subtotal-container">
      <div class="subtotal-label" style="display: flex; justify-content: space-between; width: 100%;">
        <span>Subtotal (${newText}) </span>
      <div class="subtotal-amount">${originalSubtotalValue}</div>
    </div>
    <div class="shipping-label" style="display: flex; justify-content: space-between; width: 100%;">
        <span>Shipping:</span>
        <div class="shipping-amount">FREE</div>
    </div>
    </div>
    <div class="total" style="display: flex; justify-content: space-between; width: 100%;">Total:
        <div class="bottom-subtotal-amount">${originalSubtotalValue}</div>
    </div>
    <div class="shipping-message">Taxes calculated at checkout</div>
    <button class="secure-checkout-btn">
      <img src="${cart_img_lock_secure}" alt="Secure Checkout">
      Secure checkout
    </button>
    <div class="checkout-label">Available at Checkout:</div>
    <div class="payment-options-container">
        <div class="payment-options">
            <img src="${cart_img_all_logo_payment}" alt="Payment Options">
        </div>
    </div>`;

    borderContainer.parentNode.insertBefore(
      newContainer,
      borderContainer.nextSibling
    );

    if (window.innerWidth <= 768) {
      const clonedContainer = newContainer.cloneNode(true);

      clonedContainer.querySelector(".checkout-label").style.display = "none";
      clonedContainer.querySelector(
        ".payment-options-container"
      ).style.display = "none";

      newContainer.querySelector(".secure-checkout-btn").style.display = "none";

      const targetForm = document.querySelector("form#cartform");
      if (targetForm) {
        targetForm.parentNode.insertBefore(clonedContainer, targetForm);
      }
    }
  }
};

const insertTitleBreak = () => {
  const linkContainers = document.querySelectorAll(
    ".cart-product-item .ti-link-contain"
  );
  linkContainers.forEach((linkContain) => {
    const titleLink = linkContain.querySelector("a:not(.custom-remove-style)");
    if (titleLink) {
      const words = titleLink.innerText.split(" ");
      let newText = "";
      for (let i = 0; i < words.length; i++) {
        newText += words[i];
        if ((i + 1) % 5 === 0) {
          newText += "<br>";
        } else if (i < words.length - 1) {
          newText += " ";
        }
      }
      titleLink.innerHTML = newText;
    }
  });
};

const rearrangeAndStyle = () => {
  if (window.innerWidth >= 768) return;

  const cartListContainer = document.querySelector(".cart_list_container");
  const alertContainer = document.querySelector(".ti-alert-container");

  cartListContainer.after(alertContainer);
  alertContainer.style.width = "100%";
};

const toggleDetails = () => {
  if (window.innerWidth >= 768) return;

  const downArrowUrl = cart_img_down;
  const upArrowUrl = cart_img_up;

  const cartItems = document.querySelectorAll(".item.cart-product-item");

  cartItems.forEach((cartItem) => {
    const subtotalContainer = cartItem.querySelector(".ti-subtotal-container");
    const colNotImage = cartItem.querySelector(".col-notimage");
    const desc = cartItem.querySelector(".col-notimage .desc");
    if (!desc) return;

    colNotImage.parentNode.insertBefore(desc, colNotImage.nextSibling);

    const title = desc.querySelector(".title");
    if (!title) return;

    const wrapperDiv = document.createElement("div");
    wrapperDiv.innerHTML = subtotalContainer.innerHTML;
    subtotalContainer.innerHTML = "";
    subtotalContainer.appendChild(wrapperDiv);

    subtotalContainer.style.display = "flex";
    subtotalContainer.style.flexDirection = "column";

    const detailsToggle = document.createElement("div");
    detailsToggle.style.cursor = "pointer";

    const textElement = document.createElement("span");
    textElement.textContent = "View Details";
    detailsToggle.appendChild(textElement);

    const downArrowImg = document.createElement("img");
    downArrowImg.src = downArrowUrl;
    downArrowImg.style.cursor = "pointer";
    downArrowImg.style.display = "";
    downArrowImg.style.height = "12px";
    downArrowImg.style.width = "12px";
    downArrowImg.style.marginLeft = "5px";

    const upArrowImg = document.createElement("img");
    upArrowImg.src = upArrowUrl;
    upArrowImg.style.cursor = "pointer";
    upArrowImg.style.display = "none";
    upArrowImg.style.height = "12px";
    upArrowImg.style.width = "12px";
    upArrowImg.style.marginLeft = "5px";

    detailsToggle.appendChild(downArrowImg);
    detailsToggle.appendChild(upArrowImg);

    desc.style.display = "none";
    title.style.display = "none";

    detailsToggle.addEventListener("click", (event) => {
      event.stopPropagation();
      const isHidden =
        desc.style.display === "none" || desc.style.display === "";
      desc.style.display = isHidden ? "flex" : "none";
      title.style.display = isHidden ? "flex" : "none";
      downArrowImg.style.display = isHidden ? "none" : "";
      upArrowImg.style.display = isHidden ? "" : "none";
      textElement.textContent = isHidden ? "Hide Details" : "View Details";
    });

    [...subtotalContainer.children].forEach((child) => {
      if (child !== detailsToggle) {
        child.addEventListener("click", (event) => {
          event.stopPropagation();
          event.preventDefault();
        });
      }
    });

    subtotalContainer.appendChild(detailsToggle);

    const lineItems = [
      ...desc.querySelectorAll(".line-items li:not(.visually-hidden)"),
    ];
    const prices = [
      ...cartItem.querySelectorAll(".item-price .cart-item-price ul li"),
    ];

    lineItems.forEach((lineItem, index) => {
      if (prices[index]) {
        lineItem.innerHTML += `<span style="margin-left: 10px">${prices[
          index
        ].textContent.trim()}</span>`;
      }
    });
  });
};

const updateCartPrices = () => {
  if (window.innerWidth >= 768) return;

  const cartItems = document.querySelectorAll(".cart-product-item");

  cartItems.forEach((item) => {
    const priceElement = item.querySelector(
      ".col-notimage .item-price .theme-money span"
    );
    if (priceElement) {
      const price = priceElement.textContent;
      const targetElement = item.querySelector(".ti-price");
      if (targetElement) {
        const priceContainer = document.createElement("div");
        priceContainer.style.display = "flex";
        priceContainer.style.flexDirection = "row";
        priceContainer.style.paddingTop = "38px";
        priceContainer.style.paddingTop = "11px";
        const newPriceElement = document.createElement("span");
        newPriceElement.innerText = price;
        priceContainer.appendChild(targetElement.cloneNode(true));
        priceContainer.appendChild(newPriceElement);

        targetElement.replaceWith(priceContainer);
      }
    }
  });
};

const modifyCartItems = () => {
  if (window.innerWidth >= 768) return;

  const cartItems = document.querySelectorAll("li.cart-product-item");
  cartItems.forEach((item) => {
    const lineItems = item.querySelectorAll(
      "ul.line-items > li:not(.visually-hidden)"
    );
    lineItems.forEach((lineItem, index, selfArray) => {
      const spans = lineItem.querySelectorAll("span");
      if (spans.length < 3) return;
      const descriptionContainer = document.createElement("div");
      const priceContainer = document.createElement("div");
      descriptionContainer.appendChild(spans[0]);
      descriptionContainer.appendChild(spans[1]);
      descriptionContainer.classList.add("customFlexColumn");
      priceContainer.appendChild(spans[2]);
      lineItem.appendChild(descriptionContainer);
      lineItem.appendChild(priceContainer);
      lineItem.classList.add("customFlexRow");

      if (index === selfArray.length - 1) {
        lineItem.style.border = "none";
      }

      if (spans[2].innerText.trim() === "$0.00") {
        priceContainer.style.display = "none";
      }
    });
  });
};

let rearrangeDivs = () => {
  document.querySelectorAll(".cart-product-item").forEach((item) => {
    let li = item.querySelector(".ti-subtotal-container");
    let subtotalSpan = item.querySelector(
      ".ti-subtotal-container > div:nth-child(1) > .ti-subtotal"
    );

    let priceSpan = item.querySelector(
      ".ti-subtotal-container > div:nth-child(1) > .ti-product-price"
    );
    let detailsDiv = item.querySelector(
      ".ti-subtotal-container > div:nth-child(2)"
    );

    let subtotalDiv = document.createElement("div");
    if (subtotalSpan) {
      subtotalDiv.appendChild(subtotalSpan);
    }

    let priceDiv = document.createElement("div");
    if (priceSpan) {
      priceDiv.appendChild(priceSpan);
    }
  });
};

let addBorderDiv = () => {
  if (window.innerWidth >= 768) return;
  let tiLinkContainElements = document.querySelectorAll(
    ".item.cart-product-item .ti-link-contain"
  );

  tiLinkContainElements.forEach((element) => {
    element.insertAdjacentHTML(
      "afterend",
      '<div style="border-top: 2px solid #ddd; width: 90%; margin: 22px auto;"></div>'
    );
  });
};

const initializeMobileCheckoutBehavior = () => {
  const isElementInViewport = (el) => {
    const rect = el.getBoundingClientRect();
    return (
      rect.top >= 0 &&
      rect.left >= 0 &&
      rect.bottom <=
        (window.innerHeight || document.documentElement.clientHeight) &&
      rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
  };

  const createClonedButton = (original) => {
    const clone = original.cloneNode(true);
    const wrapper = document.createElement("div");
    wrapper.className = "ti-border-container";
    wrapper.style.position = "fixed";
    wrapper.style.bottom = "0";
    wrapper.style.left = "0";
    wrapper.style.right = "0";
    wrapper.style.zIndex = "1000";
    wrapper.style.backgroundColor = "white";
    wrapper.style.textAlign = "center";
    wrapper.style.justifyContent = "center";
    wrapper.style.alignItems = "center";
    wrapper.style.padding = "20px 10px";
    wrapper.style.boxSizing = "border-box";

    clone.removeAttribute("id");
    clone.classList.add("cloned-checkout-btn");
    clone.addEventListener("click", () => {
      document.querySelector(".js-checkout-btn").click();
    });
    clone.style.margin = "0 auto";
    clone.style.width = "90%";

    wrapper.appendChild(clone);
    document.body.appendChild(wrapper);
    return clone;
  };

  window.addEventListener("scroll", () => {
    if (window.innerWidth <= 767) {
      const originalButton = document.querySelector(".secure-checkout-btn");
      let clonedButton = document.querySelector(".cloned-checkout-btn");
      if (!clonedButton) {
        clonedButton = createClonedButton(originalButton);
      }
      if (isElementInViewport(originalButton)) {
        clonedButton.parentNode.style.display = "none";
      } else {
        clonedButton.parentNode.style.display = "block";
      }
    }
  });
};

const addHandlers = () => {
  document.querySelectorAll(".secure-checkout-btn").forEach((btn) => {
    btn.addEventListener("click", (e) => {
      e.preventDefault();
      e.stopPropagation();
      document.querySelector(".js-checkout-btn").click();
    });
  });
};

let transplantAlertContainer = () => {
  let alertContainer = document.querySelector(".ti-alert-container");
  let cartListContainer = document.querySelector(".cart_list_container");

  if (alertContainer && cartListContainer) {
    cartListContainer.insertBefore(
      alertContainer,
      cartListContainer.firstChild
    );
    alertContainer.style.width = "100%";
  }
};

const adjustChatText = () => {
  let chatText = document.querySelector(".mobile_view .ti-chat-text");
  let breakElement = chatText ? chatText.querySelector("br") : null;
  let screenWidth = window.innerWidth;
  if (chatText && breakElement) {
    if (screenWidth <= 350) {
      breakElement.style.display = "none";
    } else {
      breakElement.style.display = "block";
      chatText.style.color = "";
    }
  }
};

setInterval(adjustChatText, 250);

function tiTESTNAMETracking() {
  let removeButtons = document.querySelectorAll(".custom-remove-style");

  if (removeButtons.length > 0) {
    removeButtons.forEach((button) => {
      button.addEventListener("click", (event) => {
        window.dataLayer.push({
          event: "vwo_test_event",
          vwo_event_name: "cart_remove_item_click",
        });
      });
    });
  }

  let checkExist = setInterval(function () {
    let checkoutButtons = document.querySelectorAll(
      ".secure-checkout-btn, .secure-checkout-btn.cloned-checkout-btn"
    );

    if (checkoutButtons.length > 0) {
      checkoutButtons.forEach((button) => {
        button.addEventListener("click", (event) => {
          window.dataLayer.push({
            event: "vwo_test_event",
            vwo_event_name: "cart_secure_checkout",
          });
        });
      });
      clearInterval(checkExist);
    }
  }, 250);
}

try {
  if (
    document.readyState === "complete" ||
    (document.readyState !== "loading" && !document.documentElement.doScroll)
  ) {
    cartOptimizationTest();
  } else {
    document.addEventListener("DOMContentLoaded", cartOptimizationTest);
  }
} catch (err) {
  const e = {
    dev: "U05EXFD9F6C",
    vwotest: "32",
    vwodesc: "JINS-Cart-Optimization-V2-Sep2023 - Variation 1",
    type: "vwo",
    message: err.toString(),
    stack: err.stack,
    source: window.location.href,
  };
  const x = new XMLHttpRequest();
  x.open("POST", "https://us-central1-tixray.cloudfunctions.net/err", !0),
    x.send(JSON.stringify(e));
}

window.addEventListener("pageshow", function () {
  $(".secure-checkout-btn").each(function () {
    var $button = $(this);
    var originalHtml = $button.data("checkout-button-html");
    $button.prop("disabled", false).removeClass("jins-checkout-processing");

    if (originalHtml) {
      $button.html(originalHtml);
    }

  });
});
